import { render, staticRenderFns } from "./ValuesSlider.vue?vue&type=template&id=16302056&"
import script from "./ValuesSlider.vue?vue&type=script&lang=js&"
export * from "./ValuesSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports